module.exports = __webpack_public_path__ + "static/media/Sports.ade7982f.svg";